export const RECOMMENDATION_PLACEMENT = {
  pdpRelatedProducts: 'pdp_related_products',
  pdpSoldOut: 'pdp_sold_out',
  cartModalCrossSell: 'cart_modal_cross_sell',
} as const satisfies Record<string, RecommendationTrackingPlacement>;

export type RecommendationPlacement =
  (typeof RECOMMENDATION_PLACEMENT)[keyof typeof RECOMMENDATION_PLACEMENT];
